import type {ClientInitializationStatus} from "../../hooks/clientInitialization";

interface ClientSearchKeyState {
    readonly queryType: string;
    readonly query: string;
    readonly page: number;
    readonly accountQuery: boolean;
    readonly viewerUid: string | null;
}

interface SearchClientState {
    readonly hasServerResults: boolean;
    readonly accountQuery: boolean;
    readonly accountsViewStatus: ClientInitializationStatus;
    readonly projectClientStatus: ClientInitializationStatus;
    readonly hasResolvedClientSearch: boolean;
}

export function createClientSearchKey(state: ClientSearchKeyState): string {
    const viewerScope = state.accountQuery ? state.viewerUid : null;
    return JSON.stringify([state.queryType, state.query, state.page, viewerScope]);
}

export function isSearchClientPending(state: SearchClientState): boolean {
    if (state.hasServerResults) return false;
    const status = state.accountQuery ? state.accountsViewStatus : state.projectClientStatus;
    return status === "loading" || (status === "ready" && !state.hasResolvedClientSearch);
}

export function hasSearchClientFailed(state: SearchClientState): boolean {
    if (state.hasServerResults) return false;
    return (state.accountQuery ? state.accountsViewStatus : state.projectClientStatus) === "error";
}
